import { render } from "./XIconSolidHistory.vue?vue&type=template&id=1739446f"
import script from "./XIconSolidHistory.vue?vue&type=script&lang=js"
export * from "./XIconSolidHistory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidHistory.vue"]])

export default __exports__